// File Name: lib/matchTime.js
//
// Pure helpers shared by the match pages. Kept apart from ynoMatchDb.js so the
// clock logic can be unit tested without initialising Firebase.

/** Firestore Timestamp | Date | ISO string | epoch number | null -> ms or null. */
export function toMillis(v) {
  if (v === null || v === undefined) return null;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (typeof v.toDate === 'function') return v.toDate().getTime();
  if (v instanceof Date) return v.getTime();
  if (typeof v === 'number') return v;
  const parsed = Date.parse(v);
  return Number.isNaN(parsed) ? null : parsed;
}

/** Trim + uppercase, the way the app normalises a typed code. */
export function normaliseCode(raw) {
  return String(raw || '').trim().toUpperCase();
}

/**
 * Is this `team` field side B?
 *
 * ⚠️ Firestore stores the side as UPPERCASE 'A' / 'B' — see TeamSideX.id in the
 * app's models.dart. Comparing against 'b' silently files every Team B player
 * and every Team B goal under Team A, which looks like working code and reads as
 * wrong data.
 *
 * Strict equality on purpose: the app's TeamSideX.fromId is
 * `v == 'B' ? b : a`, so anything else — including a stray lowercase 'b' — is
 * side A there, and must be side A here too.
 */
export function isSideB(team) {
  return team === 'B';
}
